// ---------------- HMR -------------------------------
if (module.hot) {
  module.hot.accept()
}
